export function LogoMark({ size = 32, className = "" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Funded Traders Club"
      width={size}
      height={size}
      className={`rounded-xl border border-line object-cover ${className}`}
      data-testid="brand-mark"
    />
  );
}

export function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <LogoMark size={compact ? 28 : 34} />
      <span className="font-display font-800 tracking-tight text-white text-base leading-none">
        FUNDED TRADERS <span className="text-gradient">CLUB</span>
      </span>
    </span>
  );
}
